const posts = {
    
    state : {
        posts_api_fetch_err_status: false,
        posts_api_pending_status: true,
        posts : []
    },

    getters: {
        getPosts(state){
            return state.posts
        },
        getPostsApiFetchErrStatus(state){
            return state.posts_api_fetch_err_status
        },
        getPostsApiPendingStatus(state){
            return state.posts_api_pending_status
        }
    },
    actions:{
        initPostosApi({commit,state}){
            console.log('intiPostsApi');
            fetch('https://jsonplaceholder.typicode.com/posts')
                .then(response => response.json())
                .then(json =>commit("INITPOSTSAPI",json)).catch(
                    err => {state.posts_api_fetch_err_status = true;console.log(err)}
                ).finally(
                    function(){state.posts_api_pending_status = false}
                )
        }
    },
    mutations:{
        INITPOSTSAPI(state,payload){
           state.posts = payload
        }
    }
}
export default posts